import { FiUser, FiTarget, FiActivity } from "react-icons/fi"
import { cn } from "@/lib/utils"

const ROWS = [
    { key: "nom", label: "Nom" },
    { key: "prenom", label: "Prénom" },
    { key: "age", label: "Âge" },
    { key: "sexe", label: "Sexe" },
    { key: "taille", label: "Taille", suffix: " cm" },
    { key: "poids", label: "Poids", suffix: " kg" },
    { key: "objectif", label: "Objectif" },
]

export function DashboardChatBot({ userInfo, currentStep, questions }) {
    const filled = ROWS.filter((r) => userInfo[r.key]).length
    const progress = questions.length ? (currentStep / questions.length) * 100 : 0

    return (
        <div className="hidden w-56 shrink-0 flex-col border-l border-border bg-muted/40 p-4 sm:flex">
            <div className="mb-3 flex items-center gap-2">
                <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary/15 text-primary">
                    <FiUser className="h-4 w-4" />
                </div>
                <h3 className="font-poppins text-sm font-semibold text-foreground">Vos infos</h3>
            </div>

            <div className="flex-1 space-y-1.5 rounded-xl border border-border bg-card p-3 text-sm">
                {ROWS.map((row) => (
                    userInfo[row.key] ? (
                        <div key={row.key} className="flex justify-between gap-2">
                            <span className="text-muted-foreground">{row.label}</span>
                            <span className="text-right font-medium text-foreground">
                                {userInfo[row.key]}{row.suffix ?? ""}
                            </span>
                        </div>
                    ) : null
                ))}
                {!userInfo.nom && (
                    <p className="flex items-center gap-1.5 text-xs italic text-muted-foreground">
                        <FiActivity className="h-3.5 w-3.5" />
                        Les infos apparaîtront ici...
                    </p>
                )}
            </div>

            {currentStep < questions.length && (
                <div className="mt-4">
                    <div className="mb-1.5 flex items-center justify-between text-xs text-muted-foreground">
                        <span className="flex items-center gap-1">
                            <FiTarget className="h-3.5 w-3.5 text-cwfGreen" />
                            Progression
                        </span>
                        <span className="font-medium text-foreground">{currentStep}/{questions.length}</span>
                    </div>
                    <div className="h-2 overflow-hidden rounded-full bg-muted">
                        <div
                            className={cn(
                                "h-full rounded-full bg-gradient-to-r from-primary to-cwfGreen transition-all duration-500"
                            )}
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                    <p className="mt-1 text-[11px] text-muted-foreground">{filled} champ(s) rempli(s)</p>
                </div>
            )}
        </div>
    )
}